"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BcDataTableLabelCell = void 0;
var common_constants_1 = require("../../../../common/constants/common-constants");
var BcDataTableLabelCell = (function () {
    function BcDataTableLabelCell() {
    }
    BcDataTableLabelCell.prototype.render = function (cell) {
        var newCell = document.createElement(common_constants_1.BcCommonConstants.TD_TAG);
        var label = document.createElement(common_constants_1.BcCommonConstants.LABEL_TAG);
        if (cell.class != undefined) {
            label.classList.add(cell.class);
        }
        label.textContent = String(cell.value);
        newCell.appendChild(label);
        return newCell;
    };
    return BcDataTableLabelCell;
}());
exports.BcDataTableLabelCell = BcDataTableLabelCell;
